(() => {
  function init(root) {
    root.querySelectorAll('[data-ck-campaign]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-campaign-slide]')];
      const choices = [...hero.querySelectorAll('[data-campaign-choice]')];
      const pause = hero.querySelector('[data-campaign-pause]');
      const fills = choices.map(button => button.querySelector('.ck-campaign-progress__fill'));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const duration = 6500;
      let paused = reducedMotion.matches;
      let visible = true;
      let focused = false;
      let elapsed = 0;
      let previousTime = 0;
      let frame;
      const firstImage = slides[0]?.querySelector('img');
      const warmNextImage = () => slides.slice(1).forEach(slide => {
        const img = slide.querySelector('img');
        if (img) { img.fetchPriority = 'low'; img.loading = 'eager'; }
      });
      if (firstImage?.complete) warmNextImage();
      else firstImage?.addEventListener('load', warmNextImage, { once: true });
      let activeIndex = 0;
      function renderProgress() {
        fills.forEach((fill, i) => {
          if (fill) fill.style.transform = `scaleX(${i === activeIndex ? elapsed / duration : 0})`;
        });
        if (pause) {
          pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
          pause.firstElementChild.textContent = paused ? '>' : 'II';
        }
      }
      function show(index) {
        activeIndex = (index + slides.length) % slides.length;
        index = activeIndex;
        elapsed = 0;
        const current = slides[index];
        hero.querySelector('[data-campaign-title]').textContent = current.dataset.title;
        hero.querySelector('[data-campaign-line]').textContent = current.dataset.line;
        hero.querySelector('[data-campaign-label]').textContent = current.dataset.label;
        hero.dataset.campaignPromotion = current.dataset.note ? 'true' : 'false';
        const note = hero.querySelector('[data-campaign-note]');
        if (note) { note.textContent = current.dataset.note || ''; note.hidden = !current.dataset.note; }
        hero.querySelector('.ck-campaign-hero__primary').href = current.dataset.link;
        slides.forEach((slide, i) => { slide.hidden = i !== index; });
        choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        renderProgress();
      }
      hero.querySelector('[data-campaign-prev]')?.addEventListener('click', () => show(activeIndex - 1));
      hero.querySelector('[data-campaign-next]')?.addEventListener('click', () => show(activeIndex + 1));
      let touchStart;
      hero.addEventListener('touchstart', event => {
        if (event.touches.length !== 1 || event.target.closest('a,button')) return;
        touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }, { passive: true });
      hero.addEventListener('touchend', event => {
        if (!touchStart) return;
        const deltaX = event.changedTouches[0].clientX - touchStart.x;
        const deltaY = event.changedTouches[0].clientY - touchStart.y;
        if (Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY) * 1.5) show(activeIndex + (deltaX < 0 ? 1 : -1));
        touchStart = undefined;
      }, { passive: true });
      hero.addEventListener('touchcancel', () => { touchStart = undefined; }, { passive: true });
      choices.forEach((button, index) => {
        button.addEventListener('click', () => show(index));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
          show(next);
          choices[next].focus();
        });
      });
      pause?.addEventListener('click', () => {
        paused = !paused;
        focused = false;
        renderProgress();
      });
      hero.addEventListener('focusin', event => {
        focused = event.target.matches(':focus-visible');
      });
      hero.addEventListener('focusout', event => {
        focused = hero.contains(event.relatedTarget);
      });
      const onMotionChange = () => {
        paused = reducedMotion.matches;
        renderProgress();
      };
      reducedMotion.addEventListener('change', onMotionChange);
      const observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: .1 })
        : null;
      observer?.observe(hero);
      function tick(time) {
        if (!hero.isConnected) {
          observer?.disconnect();
          reducedMotion.removeEventListener('change', onMotionChange);
          return;
        }
        const delta = previousTime ? Math.min(time - previousTime, 100) : 0;
        previousTime = time;
        if (!paused && visible && !focused && !document.hidden && slides.length > 1) {
          elapsed += delta;
          if (elapsed >= duration) show(activeIndex + 1);
          else if (fills[activeIndex]) fills[activeIndex].style.transform = `scaleX(${elapsed / duration})`;
        }
        frame = requestAnimationFrame(tick);
      }
      const onUnload = event => {
        if (!event.target.contains(hero)) return;
        cancelAnimationFrame(frame);
        observer?.disconnect();
        reducedMotion.removeEventListener('change', onMotionChange);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
      renderProgress();
      frame = requestAnimationFrame(tick);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();


